<template>
  <div class="detailBox">
    <!-- 基础信息 - 页面头部独立展示 -->
    <div class="baseInfoSection">
      <div class="baseInfoHeader">
        <h3 class="sectionTitle">美食基础信息</h3>
        <el-button
          type="primary"
          @click="onSaveBase()"
          :loading="state.saving"
          :icon="Check"
        >
          保存基础信息
        </el-button>
      </div>
      <el-form
        :model="state.model"
        label-width="100px"
        :scroll-to-error="true"
        ref="formDom"
        inline
        class="baseInfoForm"
      >
        <div class="formGrid">
          <el-form-item
            label="状态"
            prop="IsQy"
            :rules="[
              { required: true, message: '请选择状态', trigger: 'blur' },
            ]"
          >
            <el-switch
              v-model="state.model.IsQy"
              inline-prompt
              active-text="上架"
              inactive-text="下架"
            />
          </el-form-item>

          <el-form-item
            label="美食名称"
            prop="Mc"
            :rules="[
              { required: true, message: '请输入美食名称', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="state.model.Mc"
              placeholder="例如：特色精品套餐"
            />
          </el-form-item>

          <el-form-item label="供应商" prop="GysId">
            <el-select
              v-model="state.model.GysId"
              placeholder="--请选择供应商--"
              :disabled="!Array.isArray(state.gysData)"
            >
              <el-option
                v-for="item in state.gysData || []"
                :key="item.Id"
                :label="item.Mc"
                :value="item.Id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="简介" class="formItemFull">
            <el-input
              type="textarea"
              v-model="state.model.Jj"
              :autosize="{ minRows: 2 }"
              placeholder="美食的简要描述"
            />
          </el-form-item>

          <div class="formItemGroup">
            <el-form-item label="是否预约" prop="IsYuyue" class="formItemYuyue">
              <el-switch
                v-model="state.model.IsYuyue"
                inline-prompt
                active-text="需要"
                inactive-text="不需要"
              />
            </el-form-item>
            <el-form-item
              v-if="state.model.IsYuyue"
              label="提前天数"
              prop="YuyueTianShu"
              class="formItemYuyueTianShu"
            >
              <el-input-number
                v-model="state.model.YuyueTianShu"
                :min="1"
                controls-position="right"
                placeholder="请指定天数"
              />
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <!-- Tab 区域 -->
    <div class="tabSection">
      <el-tabs v-model="state.activeTab" :before-leave="onTabsChange">
        <!-- 图文详情 -->
        <el-tab-pane lazy label="图文详情" name="tuwen">
          <div class="detail-block">
            <div class="detail-block-header">
              <span class="detail-block-title">图文详情</span>
              <span class="detail-block-tip">详细的图文介绍，展示美食的特色与亮点</span>
            </div>
            <div style="padding: 8px 0;">
              <c_editor
                v-model:value="state.extendData.TwDetail"
                :key="'twDetail_' + editorVersion"
                placeholder="请输入图文详情内容..."
              />
            </div>
          </div>
        </el-tab-pane>

        <!-- 图片管理（封面图） -->
        <el-tab-pane lazy label="图片管理" name="tupian">
          <el-form-item style="width: 99%; display: flex; align-items: flex-start">
            <div style="display: flex; flex-wrap: wrap; gap: 10px">
              <div
                v-for="(tp, index) in state.imageData.Tps"
                :key="tp"
                :style="{
                  marginTop: '10px',
                  marginRight: '10px',
                  borderRadius: '5px',
                  overflow: 'hidden',
                  position: 'relative',
                  border: state.imageData.Fm === tp ? '3px solid #409eff' : '3px solid transparent',
                  boxSizing: 'border-box',
                }"
                class="uploadTpBox"
              >
                <img class="uploadTp" :src="getImageUrl(tp)" referrerpolicy="no-referrer" />
                <div style="text-align: center; padding: 8px; background: #f5f7fa">
                  <el-radio-group v-model="state.imageData.Fm" style="display: flex; justify-content: center">
                    <el-radio :label="tp" size="small">设为封面</el-radio>
                  </el-radio-group>
                </div>
                <div class="uploadDel">
                  <div class="uploadActions">
                    <el-icon size="28" class="actionIcon" @click="onPreviewTp(index)"><View /></el-icon>
                    <el-icon size="28" class="actionIcon" @click="onDelTp(index)"><Delete /></el-icon>
                  </div>
                </div>
              </div>
            </div>
            <el-upload
              :show-file-list="false"
              :auto-upload="false"
              :multiple="true"
              accept=".jpeg,.jpg,.png,.gif"
              :on-change="onUpload"
            >
              <template #trigger>
                <div class="uploadAdd">
                  <el-icon size="30" style="margin: auto; cursor: pointer"><Plus /></el-icon>
                </div>
              </template>
            </el-upload>
          </el-form-item>
          <!-- 图片预览 -->
          <el-image-viewer
            v-if="state.preview.show"
            :url-list="state.preview.urlList"
            :initial-index="state.preview.index"
            :teleported="false"
            @close="closePreview"
          />
        </el-tab-pane>

        <!-- 使用须知 -->
        <el-tab-pane lazy label="使用须知" name="xuzhi">
          <div class="detail-block">
            <div class="detail-block-header">
              <span class="detail-block-title">使用须知</span>
              <span class="detail-block-tip">用户下单前需知悉的重要信息</span>
            </div>

            <div class="notice-section">
              <div class="notice-group">
                <div class="notice-group-title">
                  <el-icon><InfoFilled /></el-icon> 使用说明
                  <el-button size="small" text type="primary" @click="addNoticeItem('usage')">+ 添加</el-button>
                </div>
                <div v-for="(n, ni) in getNoticesByType('usage')" :key="'u'+ni" class="notice-edit-row">
                  <el-input v-model="n.content" placeholder="如：请提前预约，凭券使用..." />
                  <el-button :icon="Delete" circle size="small" @click="removeNoticeByIndex(ni, 'usage')" />
                </div>
                <div v-if="!getNoticesByType('usage').length" class="empty-tip-inline">暂无数据，点击添加</div>
              </div>

              <div class="notice-group">
                <div class="notice-group-title">
                  <el-icon><Warning /></el-icon> 退款规则
                  <el-button size="small" text type="primary" @click="addNoticeItem('refund')">+ 添加</el-button>
                </div>
                <div v-for="(n, ni) in getNoticesByType('refund')" :key="'r'+ni" class="notice-edit-row">
                  <el-input v-model="n.content" placeholder="如：未核销可全额退款..." />
                  <el-button :icon="Delete" circle size="small" @click="removeNoticeByIndex(ni, 'refund')" />
                </div>
                <div v-if="!getNoticesByType('refund').length" class="empty-tip-inline">暂无数据，点击添加</div>
              </div>

              <div class="notice-group">
                <div class="notice-group-title">
                  <el-icon><Document /></el-icon> 其他注意事项
                  <el-button size="small" text type="primary" @click="addNoticeItem('other')">+ 添加</el-button>
                </div>
                <div v-for="(n, ni) in getNoticesByType('other')" :key="'o'+ni" class="notice-edit-row">
                  <el-input v-model="n.content" placeholder="其他需要提醒用户的信息..." />
                  <el-button :icon="Delete" circle size="small" @click="removeNoticeByIndex(ni, 'other')" />
                </div>
                <div v-if="!getNoticesByType('other').length" class="empty-tip-inline">暂无数据，点击添加</div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!-- 套餐管理 -->
        <el-tab-pane lazy label="套餐管理" name="tc">
          <c_MeiShiTcList
            :key="productId || 0"
            :spId="productId"
          />
        </el-tab-pane>

        <!-- 销售控制 -->
        <el-tab-pane name="gz">
          <template #label>
            <text :style="{ color: state.tcData?.length > 0 ? '' : '#a2a2a2' }">
              销售控制
            </text>
          </template>
          <c_MeiShiGzList
            :spId="productId"
            :key="state.gzKey"
          />
        </el-tab-pane>

        <!-- 评价信息 -->
        <el-tab-pane lazy label="评价信息" name="pingjia">
          <div class="pjWrap">
            <!-- 评价统计概览 -->
            <div class="pjSummary" v-if="state.pjSummary.totalCount > 0">
              <div class="pjScoreBox">
                <span class="pjScore">{{ state.pjSummary.avgRating }}</span>
                <span class="pjUnit">/5</span>
                <div class="pjStars">
                  <el-rate
                    v-model="state.pjSummary.avgRating"
                    disabled
                    show-score
                    text-color="#ff9900"
                  />
                </div>
                <span class="pjTotal"
                  >共 {{ state.pjSummary.totalCount }} 条评价</span
                >
              </div>
              <div class="pjDist">
                <div class="pjDistItem" v-for="i in 5" :key="i">
                  <span class="pjDistLabel">{{ 6 - i }}星</span>
                  <el-progress
                    :percentage="getRatingPercent(6 - i)"
                    :show-text="false"
                    :stroke-width="8"
                    color="#f5a623"
                  />
                  <span class="pjDistCount">{{ getRatingCount(6 - i) }}</span>
                </div>
              </div>
            </div>

            <!-- 评价列表 -->
            <div class="pjList">
              <div class="pjItem" v-for="pj in pagedPjList" :key="pj.Id">
                <div class="pjHeader">
                  <span class="pjUser">{{ pj.CjrXm }}</span>
                  <el-rate v-model="pj.Xj" disabled size="small" />
                  <span class="pjTime">{{ formatTime(pj.Cjsj) }}</span>
                </div>
                <div class="pjTags" v-if="pj.PjBq">
                  <el-tag
                    v-for="tag in pj.PjBq.split(',')"
                    :key="tag"
                    size="small"
                    type="info"
                    style="margin-right: 6px"
                    >{{ tag }}</el-tag
                  >
                </div>
                <div class="pjContent">{{ pj.PjNr }}</div>
                <div class="pjImages" v-if="pj.PjTp">
                  <el-image
                    v-for="(img, idx) in pj.PjTp.split(',')"
                    :key="idx"
                    :src="$http.defaults.baseURL + img"
                    :preview-src-list="
                      pj.PjTp.split(',').map((u) => $http.defaults.baseURL + u)
                    "
                    :initial-index="idx"
                    fit="cover"
                    class="pjImg"
                  />
                </div>
                <!-- 商家回复 -->
                <div class="pjReply" v-if="pj.HfNr">
                  <div class="pjReplyHeader">
                    <span class="pjReplyLabel">商家回复</span>
                    <span class="pjReplyTime">{{ formatTime(pj.HfSj) }}</span>
                  </div>
                  <div class="pjReplyContent">{{ pj.HfNr }}</div>
                </div>
              </div>

              <!-- 分页 -->
              <div
                class="pjPagination"
                v-if="state.pjList.length > state.pjPageSize"
              >
                <el-pagination
                  v-model:current-page="state.pjPageIndex"
                  :page-size="state.pjPageSize"
                  :total="state.pjList.length"
                  layout="total, prev, pager, next"
                  background
                  small
                />
              </div>

              <!-- 暂无评价 -->
              <div
                class="pjEmpty"
                v-if="state.pjLoaded && state.pjList.length === 0"
              >
                <el-empty description="暂无评价信息" />
              </div>
            </div>
          </div>
        </el-tab-pane>

      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, reactive, ref, computed } from "vue";
import { Delete, Plus, Check, InfoFilled, Warning, Document, View } from "@element-plus/icons-vue";
import {
  meishi_edit,
  meishi_detail,
  meishi_tc_list,
  meishi_uploadtp,
  gongyingshang_select,
  home_uploadconfig,
  shangpinpingjia_getbyspid,
  shangpinpingjia_getsummary,
} from "@/http/api";
import $http from "@/http/index";
import { ElMessage } from "element-plus";

export default {
  props: {
    data: Object,
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const formDom = ref(null);
    const editorVersion = ref(0);

    const productId = computed(() => props.data?.id);

    // 分页后的评价列表
    const pagedPjList = computed(() => {
      const start = (state.pjPageIndex - 1) * state.pjPageSize;
      return state.pjList.slice(start, start + state.pjPageSize);
    });

    const state = reactive({
      saving: false,
      activeTab: "tuwen",
      // 基础信息
      model: {
        IsQy: true,
        Mc: "",
        Jj: "",
        YxKssj: "",
        YxJzsj: "",
        GysId: null,
        Yhj: 0,
      },
      gysData: [],
      imageBaseUrl: "",
      // 图片管理
      imageData: {
        Tps: [],
        Fm: "",
      },
      // 图片预览
      preview: {
        show: false,
        urlList: [],
        index: 0,
      },
      // 扩展数据（图文详情、使用须知等）
      extendData: {
        TwDetail: "",
        notices: [],
      },
      // 套餐/销售控制
      tcData: [],
      gzKey: 0,
      // 评价信息
      pjList: [],
      pjLoaded: false,
      pjPageIndex: 1,
      pjPageSize: 5,
      pjSummary: {
        totalCount: 0,
        avgRating: 0,
        ratingDistribution: {},
      },
    });

    // ==================== 数据加载 ====================

    onMounted(() => {
      loadUploadConfig();
      loadGys();
      if (productId.value) {
        loadDetail();
        onLoadTc();
      }
    });

    // 加载套餐数据（用于判断销售控制 tab 是否可进入）
    const onLoadTc = () => {
      if (!productId.value) return;
      meishi_tc_list(productId.value).then((res) => {
        if (res.status == 200) {
          state.tcData = res.data;
        }
      });
    };

    // 选项卡切换
    const onTabsChange = (value) => {
      if (value === "gz") {
        // 切换前重新加载套餐数据，确保判断准确
        return meishi_tc_list(productId.value).then((res) => {
          if (res.status == 200) {
            state.tcData = res.data;
          }
          if (state.tcData?.length <= 0) {
            ElMessage({
              type: "warning",
              message: "请先在「套餐管理」中添加套餐！",
              grouping: true,
            });
            return false;
          }
          state.gzKey = Math.random();
        });
      } else if (value === "pingjia") {
        state.pjPageIndex = 1;
        loadPingJia();
      }
    };

    const loadDetail = () => {
      meishi_detail(productId.value).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          state.model = {
            IsQy: data.IsQy,
            Mc: data.Mc || "",
            Jj: data.Jj || "",
            YxKssj: data.YxKssj || "",
            YxJzsj: data.YxJzsj || "",
            GysId: data.GysId || null,
            Yhj: data.Yhj || 0,
            IsYuyue: data.IsYuyue || false,
            YuyueTianShu: data.YuyueTianShu || null,
          };

          // 扩展表字段读取
          if (data.MeishiExtend) {
            try {
              const ext = data.MeishiExtend;
              state.extendData.TwDetail = ext.TwDetail || "";
              state.extendData.notices = Array.isArray(ext.Notices) ? ext.Notices : (typeof ext.Notices === 'string' ? JSON.parse(ext.Notices) : []);
              state.imageData.Tps = ext.Tps || data.Tp?.split(",") || [];
              state.imageData.Fm = ext.Fm || data.Fm || (state.imageData.Tps[0] || "");
            } catch (e) {
              console.warn("美食扩展数据解析失败", e);
              state.imageData.Tps = data.Tp?.split(",") || [];
              state.imageData.Fm = data.Fm || (state.imageData.Tps[0] || "");
            }
          } else {
            state.imageData.Tps = data.Tp?.split(",") || [];
            state.imageData.Fm = data.Fm || (state.imageData.Tps[0] || "");
          }

          // 数据加载完成后，重建富文本编辑器以显示图片
          editorVersion.value++;
        }
      });
    };

    const loadGys = () => {
      gongyingshang_select().then((res) => {
        if (res.status == 200) state.gysData = res.data;
      });
    };

    // ==================== 图片管理 ====================

    const loadUploadConfig = () => {
      home_uploadconfig().then((res) => {
        if (res.status == 200) {
          const config = res.data;
          if (config.useOss && config.ossBaseUrl) {
            state.imageBaseUrl = config.ossBaseUrl;
          } else {
            state.imageBaseUrl = $http.defaults.baseURL;
          }
        }
      }).catch(() => {
        state.imageBaseUrl = $http.defaults.baseURL;
      });
    };

    const getImageUrl = (tp) => {
      if (!tp) return "";
      const url = String(tp).trim();
      if (url.startsWith("http://") || url.startsWith("https://")) return url;
      if (state.imageBaseUrl) return state.imageBaseUrl + url;
      return $http.defaults.baseURL + url;
    };

    const onUpload = (file) => {
      let formData = new FormData();
      formData.append("files", file.raw);
      meishi_uploadtp(formData).then((res) => {
        if (res.status == 200) {
          state.imageData.Tps = [...state.imageData.Tps, ...res.data];
          if (!state.imageData.Fm) {
            state.imageData.Fm = state.imageData.Tps[0];
          }
        }
      });
    };

    const onDelTp = (index) => {
      state.imageData.Tps.splice(index, 1);
      if (state.imageData.Fm && !state.imageData.Tps.includes(state.imageData.Fm)) {
        state.imageData.Fm = state.imageData.Tps.length > 0 ? state.imageData.Tps[0] : "";
      }
    };

    const onPreviewTp = (index) => {
      state.preview.urlList = state.imageData.Tps.map((tp) => getImageUrl(tp));
      state.preview.index = index;
      state.preview.show = true;
    };

    const closePreview = () => {
      state.preview.show = false;
    };

    // ==================== 使用须知操作 ====================

    const getNoticesByType = (type) => {
      return (state.extendData.notices || []).filter(n => n.type === type);
    };

    const addNoticeItem = (type) => {
      state.extendData.notices.push({ type, content: '' });
    };

    const removeNoticeByIndex = (idx, type) => {
      const arr = getNoticesByType(type);
      const realItem = arr[idx];
      const realIdx = state.extendData.notices.indexOf(realItem);
      if (realIdx >= 0) state.extendData.notices.splice(realIdx, 1);
    };

    // ==================== 评价信息 ====================

    const loadPingJia = () => {
      if (!productId.value) return;
      shangpinpingjia_getbyspid(productId.value).then((res) => {
        if (res.status == 200) {
          state.pjList = res.data || [];
          state.pjLoaded = true;
        }
      });
      shangpinpingjia_getsummary(productId.value).then((res) => {
        if (res.status == 200) {
          state.pjSummary = res.data;
        }
      });
    };

    const getRatingPercent = (star) => {
      const dist = state.pjSummary?.ratingDistribution;
      const total = state.pjSummary?.totalCount;
      if (!dist || !total) return 0;
      const map = {
        1: dist?.one,
        2: dist?.two,
        3: dist?.three,
        4: dist?.four,
        5: dist?.five,
      };
      const count = map[star] || 0;
      return Math.round((count / total) * 100);
    };

    const getRatingCount = (star) => {
      const dist = state.pjSummary?.ratingDistribution;
      const map = {
        1: dist?.one,
        2: dist?.two,
        3: dist?.three,
        4: dist?.four,
        5: dist?.five,
      };
      return map[star] || 0;
    };

    const formatTime = (val) => {
      if (!val) return '';
      const str = String(val);
      return str.replace('T', ' ').replace(/\.\d+$/, '');
    };

    // ==================== 提交 ====================

    const onSaveBase = () => {
      formDom.value.validate((valid) => {
        if (!valid) return false;

        state.saving = true;

        const payload = {
          IsQy: state.model.IsQy,
          Mc: state.model.Mc,
          Jj: state.model.Jj,
          Fm: state.imageData.Fm || null,
          Tp: state.imageData.Tps.join(","),
          YxKssj: state.model.YxKssj || null,
          YxJzsj: state.model.YxJzsj || null,
          GysId: state.model.GysId,
          Yhj: state.model.Yhj,
          IsYuyue: state.model.IsYuyue || false,
          YuyueTianShu: state.model.YuyueTianShu || null,
          // 扩展数据
          TwDetail: state.extendData.TwDetail || "",
          Notices: JSON.stringify(state.extendData.notices || []),
          Tps: state.imageData.Tps,
        };

        meishi_edit(productId.value, payload)
          .then((res) => {
            if (res.status == 200) {
              proxy.$message.success("保存成功");
              loadDetail();
            }
          })
          .finally(() => {
            state.saving = false;
          });
      });
    };

    return {
      state,
      formDom,
      productId,
      editorVersion,
      // 图片管理
      getImageUrl,
      onUpload,
      onDelTp,
      onPreviewTp,
      closePreview,
      // 使用须知
      getNoticesByType,
      addNoticeItem,
      removeNoticeByIndex,
      // 套餐/销售控制
      onTabsChange,
      onLoadTc,
      // 评价信息
      pagedPjList,
      loadPingJia,
      getRatingPercent,
      getRatingCount,
      formatTime,
      // 提交
      onSaveBase,
      // icons
      Delete,
      Plus,
      Check,
      InfoFilled,
      Warning,
      Document,
      View,
    };
  },
};
</script>

<style scoped lang="less">
.detailBox {
  height: 100%;
  overflow-y: auto;
}

/* ========== 基础信息区域 ========== */
.baseInfoSection {
  background: #fff;
  border-radius: 8px;
  padding: 16px 24px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.baseInfoHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 14px;
}

.sectionTitle {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.baseInfoForm {
  margin-bottom: 0;
}

.formGrid {
  display: flex;
  flex-wrap: wrap;
  gap: 0 16px;
}

.formGrid :deep(.el-form-item) {
  flex: 0 0 calc(33.333% - 11px);
  margin-right: 0;
  margin-bottom: 14px;
}

.formGrid :deep(.el-form-item .el-select),
.formGrid :deep(.el-form-item .el-input),
.formGrid :deep(.el-form-item .el-input-number) {
  width: 100%;
}

.formGrid :deep(.formItemGroup) {
  flex: 0 0 calc(33.333% - 11px);
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
}

.formGrid :deep(.formItemGroup .el-form-item) {
  flex: 0 0 auto;
  margin-bottom: 0;
}

.formGrid :deep(.formItemGroup .formItemYuyueTianShu) {
  flex: 1;
}

.formItemFull {
  flex: 0 0 100% !important;
}

/* ========== Tab 区域 ========== */
.tabSection {
  background: #fff;
  border-radius: 8px;
  padding: 0 24px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.tabSection :deep(.el-tabs__header) {
  margin-bottom: 0;
}

/* ========== 图文详情/使用须知区块 ========== */
.detail-block {
  margin-top: 16px;
  padding: 16px 18px;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  background: #fafbfc;
}

.detail-block-header {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.detail-block-title {
  font-size: 15px;
  font-weight: 700;
  color: #303133;
  margin-right: 12px;
}

.detail-block-tip {
  font-size: 12px;
  color: #999;
}

/* ========== 购买须知分组 ========== */
.notice-section {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.notice-group {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px 14px;
  background: #fff;
}

.notice-group-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f2f2f2;

  .el-button { margin-left: auto; }
}

.notice-edit-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;

  .el-input { flex: 1; }
}

/* ========== 图片管理通用样式 ========== */
.uploadAdd {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  border-radius: 5px;
  border: 1px dashed #e2e2e2;
  display: flex;
  color: #a2a2a2;
  margin-top: 8px;
}
.uploadAdd:hover {
  background-color: rgba(100, 100, 100, 0.2) !important;
  color: #fff !important;
}
.uploadDel {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  color: #fff;
  display: none;
}
.uploadActions {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 12px;
  box-sizing: border-box;
}
.actionIcon {
  cursor: pointer;
  transition: transform 0.2s;
}
.actionIcon:hover {
  transform: scale(1.15);
}
.uploadTp {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}
.uploadTpBox:hover .uploadDel {
  display: flex !important;
}

.empty-tip-inline {
  font-size: 13px;
  color: #bbb;
}

/* ===== 评价信息 ===== */
.pjWrap {
  padding: 10px 0;
}

.pjSummary {
  display: flex;
  gap: 40px;
  padding: 20px 24px;
  background: #fafbfc;
  border-radius: 8px;
  margin-bottom: 20px;
  align-items: center;
}

.pjScoreBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 140px;
}

.pjScore {
  font-size: 42px;
  font-weight: 700;
  color: #ff9900;
  line-height: 1;
}

.pjUnit {
  font-size: 18px;
  color: #999;
  margin-bottom: 6px;
}

.pjStars {
  margin: 4px 0;
}

.pjTotal {
  font-size: 13px;
  color: #999;
  margin-top: 4px;
}

.pjDist {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pjDistItem {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pjDistLabel {
  font-size: 13px;
  color: #666;
  width: 30px;
  text-align: right;
}

.pjDistCount {
  font-size: 13px;
  color: #999;
  width: 28px;
}

.pjList {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pjItem {
  padding: 16px 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.pjHeader {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.pjUser {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.pjTime {
  font-size: 12px;
  color: #bbb;
  margin-left: auto;
}

.pjTags {
  margin-bottom: 8px;
}

.pjContent {
  font-size: 14px;
  color: #555;
  line-height: 1.7;
  margin-bottom: 10px;
  white-space: pre-wrap;
  word-break: break-word;
}

.pjImages {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.pjImg {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ebeef5;
}

.pjReply {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 10px 14px;
  margin-top: 8px;
}

.pjReplyHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.pjReplyLabel {
  font-size: 12px;
  font-weight: 600;
  color: #409eff;
}

.pjReplyTime {
  font-size: 12px;
  color: #bbb;
}

.pjReplyContent {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

.pjPagination {
  display: flex;
  justify-content: center;
  padding: 12px 0;
}

.pjEmpty {
  padding: 40px 0;
}
</style>
